import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toJS } from '../../../utils/immutableUtils';
import { fetchMarketDishLogo } from '../actions';
import {
  getMarketDishLogo,
  getFetchError,
  getIsFetchingDishLogo
} from '../selectors';
import { getIsGlobalUser } from 'features/loginSystem/selectors';

const useMarketDishLogo = ({ forceFetch = false } = {}) => {
  const dispatch = useDispatch();

  const [isMounted, setIsMounted] = useState(false);
  const marketDishLogo = useSelector(getMarketDishLogo);
  const isFetchingDishLogo = useSelector(getIsFetchingDishLogo);
  const fetchError = useSelector(getFetchError);
  const isGlobalUser = useSelector(getIsGlobalUser);
  const isFetching = !isMounted ? true : isFetchingDishLogo;
  const isFetched = !!marketDishLogo;

  useEffect(() => {
    if (isMounted) {
      return;
    }
    if (!isGlobalUser) {
      if (!isFetched || forceFetch) {
        dispatch(fetchMarketDishLogo());
      }
    }
    setIsMounted(true);
  }, [dispatch, forceFetch, isFetched, isMounted]);

  return [isFetching, isFetching ? null : toJS(marketDishLogo), fetchError];
};

export default useMarketDishLogo;
